import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

import styled, { css } from 'styled-components';
import Config from '../../config';
import { withTheme } from '../../core/ThemeProvider';
import { withStyledAttrs } from '../../helpers/styled';
import Text from '../Text';

var getStyledText = function getStyledText(type, tag) {
  return withStyledAttrs(Text, {
    type: type,
    tag: tag
  });
};

var Wrapper = styled.div.withConfig({
  displayName: "style__Wrapper",
  componentId: "sc-p6wmk6-0"
})(["display:flex;justify-content:flex-start;align-items:center;"]);
export var WrapperVariant1 = withTheme(styled(Wrapper).withConfig({
  displayName: "style__WrapperVariant1",
  componentId: "sc-p6wmk6-1"
})(function (_ref) {
  var coreTheme = _ref.coreTheme;
  return css(["flex-direction:column;padding:", "px ", "px ", "px ", "px;@media (max-width:375px){padding-left:0;padding-right:0;}"], coreTheme.space_3, coreTheme.space_6, coreTheme.space_3, coreTheme.space_6);
}));
export var WrapperVariant2 = withTheme(styled(Wrapper).withConfig({
  displayName: "style__WrapperVariant2",
  componentId: "sc-p6wmk6-2"
})(function (_ref2) {
  var flush = _ref2.flush,
      coreTheme = _ref2.coreTheme;
  return css(["flex-direction:row;padding-top:", "px;padding-bottom:", "px;", ";", ";"], coreTheme.space_1, coreTheme.space_1, Config.media.sm(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        padding: ", "px;\n      "])), coreTheme.space_2), Config.media.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        padding-top: ", "px;\n        padding-bottom: ", "px;\n        padding-left: ", "px\n        padding-right: ", "px;\n      "])), coreTheme.space_2, coreTheme.space_2, flush === 'left' ? coreTheme.space_6 : 0, flush === 'right' ? coreTheme.space_6 : 0));
}));
export var ThumbnailVariant1 = styled.div.withConfig({
  displayName: "style__ThumbnailVariant1",
  componentId: "sc-p6wmk6-3"
})(["padding-left:32px;padding-right:32px;max-width:254px;", ";"], Config.media.sm(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    padding: 0;\n  "]))));
export var ThumbnailVariant2 = styled.div.withConfig({
  displayName: "style__ThumbnailVariant2",
  componentId: "sc-p6wmk6-4"
})(["align-self:flex-start;", ";"], Config.media.sm(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    width: auto;\n    flex: 2;\n  "]))));
export var Image = styled.img.withConfig({
  displayName: "style__Image",
  componentId: "sc-p6wmk6-5"
})(["width:88px;height:88px;border-radius:50%;", ";"], Config.media.sm(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  "]))));
export var ContentVariant1 = withTheme(styled.div.withConfig({
  displayName: "style__ContentVariant1",
  componentId: "sc-p6wmk6-6"
})(["padding-top:", "px;"], function (p) {
  return p.coreTheme.space_4;
}));
export var ContentVariant2 = withTheme(styled.div.withConfig({
  displayName: "style__ContentVariant2",
  componentId: "sc-p6wmk6-7"
})(["flex:2;padding-left:", "px;", ";"], function (p) {
  return p.coreTheme.space_4;
}, Config.media.sm(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    flex: 3;\n  "])))));
export var getBodyVariant1 = function getBodyVariant1(isMobile) {
  return withTheme(getStyledText(isMobile ? 'sectionTitle' : 'header')(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    text-align: center;\n    font-family: ", ";\n    color: ", ";\n  "])), function (p) {
    return p.coreTheme.ff_sec_regular;
  }, function (p) {
    return p.coreTheme.cl_ter_base;
  }));
};
export var Title = withTheme(getStyledText('boldBody')(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (p) {
  return p.coreTheme.cl_ter_base;
}));
export var BodyVariant2 = withTheme(getStyledText('body', 'span')(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (p) {
  return p.coreTheme.cl_ter_base;
}));